import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "../../../assets/styles/content.module.scss";
import stylesIcon from "../../../assets/styles/icon.module.scss";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeadBlock from "../../../components/HeadBlock";

function ContentSayonaraNoMirai() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const location = useLocation();
  useLayoutEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const navigation: any = performance.getEntriesByType("navigation")[0];
    const coordinates = navigation.type;
    if (coordinates === "reload") setIsLoading(false);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1600);
  }, []);

  return (
    <>
      <HeadBlock
        title={"君の過去にさよならの未来を数えて"}
        path="contents/sayonara-no-mirai/detail"
      />
      <div className={styles.Content}>
        <div className={`${styles.loading} ${!isLoading && styles.hidden}`}>
          <img
            src={require("../../../assets/images/logo.svg").default}
            alt=""
          />
          <p>
            <span className={styles.word}>N</span>
            <span className={styles.word}>o</span>
            <span className={styles.word}>w</span>
            <span className={`${styles.word} ${styles.wordFirstLetter}`}>
              L
            </span>
            <span className={styles.word}>o</span>
            <span className={styles.word}>a</span>
            <span className={styles.word}>d</span>
            <span className={styles.word}>i</span>
            <span className={styles.word}>n</span>
            <span className={styles.word}>g</span>
            <span className={styles.word}>.</span>
            <span className={styles.word}>.</span>
            <span className={styles.word}>.</span>
          </p>
        </div>

        <header className={styles.header}>
          <nav className={styles.nav}>
            <h1>
              <a href="/contents/sayonara-no-mirai/detail">
                <img
                  src={
                    require("../../../assets/images/content/logo.svg").default
                  }
                  alt="PAZLE"
                  className={styles.logo}
                />
              </a>
            </h1>
            <a href="#sns" className={styles.pageToSns}>
              <i className={stylesIcon.icon_arrow_down_circle}></i>
              SNSをフォローする
            </a>
            <a
              href="/contents/sayonara-no-mirai"
              target="_blank"
              className={`${styles.navBtnSp} ${styles.btn} ${styles.btnSmall} ${styles.btnPrimary}`}
            >
              ボイスドラマ
              <br />
              を視聴する
            </a>
            <div className={styles.headerBtns}>
              <a
                href="https://twitter.com/Pazle_info"
                target="_brank"
                className={`${styles.btnTw}`}
              >
                フォローする
              </a>
              <a
                href="https://lin.ee/r4SVWtA"
                target="_brank"
                className={styles.btnLine}
              >
                <img
                  src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
                  alt="友だち追加"
                />
              </a>
              <a
                href="/contents/sayonara-no-mirai"
                target="_blank"
                className={`${styles.navBtnPc} ${styles.btn} ${styles.btnSmall} ${styles.btnPrimary}`}
              >
                ボイスドラマを視聴する
              </a>
            </div>
          </nav>
        </header>

        <main className={styles.main} id="main">
          <div className={styles.mainvisual}>
            <img
              src={require("../../../assets/images/content/sayonara-no-mirai/kv_sp.png")}
              className={`${styles.mainvisualImg} ${styles.mainvisualImgSp}`}
              alt=""
            />
            <img
              src={require("../../../assets/images/content/sayonara-no-mirai/kv_pc.png")}
              className={`${styles.mainvisualImg} ${styles.mainvisualImgPc}`}
              alt=""
            />
            <div className={styles.inner}>
              <div className={styles.text}>
                <h1>
                  <img
                    src={
                      require("../../../assets/images/content/sayonara-no-mirai/logo.svg")
                        .default
                    }
                    alt="君の過去にさよならの未来を数えて"
                  />
                </h1>
                <p className={`${styles.tag} ${styles.inverse}`}>
                  PAZLEボイスドラマ第二弾公開！
                  <br />
                  タイムマシンを巡る、時を超えたラブストーリー
                </p>
              </div>
              <a
                href="/contents/sayonara-no-mirai"
                target="_blank"
                className={`${styles.btn} ${styles.btnLarge} ${styles.btnPrimary}`}
              >
                ボイスドラマを視聴する
              </a>
              <div className={`${styles.mainvisualCsp} ${styles.cspSp}`}>
                <img
                  src={
                    require("../../../assets/images/logo_csp_s_white.svg")
                      .default
                  }
                  alt=""
                />
                <p>
                  作品のご購入でクリエイターに
                  <br />
                  売上の一部が還元されます
                </p>
              </div>
              <div className={`${styles.mainvisualCsp} ${styles.cspPc}`}>
                <img
                  src={
                    require("../../../assets/images/logo_csp_white.svg").default
                  }
                  alt=""
                />
                <p>
                  作品をご購入いただくとクリエイターに売上の一部が還元されます
                </p>
              </div>
            </div>
            <img
              src={require("../../../assets/images/content/sayonara-no-mirai/actor_pc.png")}
              className={styles.actorPc}
              alt=""
            />
            <div className={styles.scroll}></div>
          </div>

          <div className={styles.actor}>
            <ul>
              <li>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/actor_toki_sp.png")}
                  className={styles.actorPc}
                  alt=""
                />
                <div className={styles.text}>
                  <p className={styles.role}>真木 心一 役</p>
                  <p className={styles.name}>
                    土岐 隼一<small>さん</small>
                  </p>
                </div>
                <div
                  className={`${styles.introduction} ${styles.introductionSp}`}
                >
                  <p>
                    土岐 隼一（トキ シュンイチ） 声優。
                    <br />
                    <br />
                    5月7日生まれ、東京都出身。A型。出演作品は、『異世界召喚は二度目です』（セツ役）、『勇者が死んだ！』（トウカ・スコット／シオン・ブレイダン役）、『Paradox
                    Live THE
                    ANIMATION』（征木北斎役）、『東京リベンジャーズ』（羽宮一虎役）、『原神』（フレミネ役）、『プロジェクトセカイ
                    カラフルステージ! feat.初音ミク』（神代類役）など。
                  </p>
                </div>
              </li>
              <li>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/actor_koichi_sp.png")}
                  className={styles.actorPc}
                  alt=""
                />
                <div className={styles.text}>
                  <p className={styles.role}>崎野 夢芽 役</p>
                  <p className={styles.name}>
                    小市 眞琴<small>さん</small>
                  </p>
                </div>
                <div
                  className={`${styles.introduction} ${styles.introductionSp}`}
                >
                  <p>
                    小市 眞琴（コイチ マコト） 声優。
                    <br />
                    <br />
                    2月17日生まれ、東京都出身。出演作品は、『The Legend of
                    Heroes 閃の軌跡 Northern
                    War』（ラヴィアン・ウィンスレット役）、『るろうに剣心
                    -明治剣客浪漫譚-』（明神弥彦役）、『アンデッドガール・マーダーファルス』（馳井静句役）、『地獄楽』（ヌルガイ役）、『シャングリラ・フロンティア〜クソゲーハンター、神ゲーに挑まんとす〜』（オイカッツォ
                    / 魚臣慧役）、『アイドルマスター
                    シンデレラガールズ』（結城晴役）など。
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <section className={styles.story}>
            <div className={styles.title}>
              <h2 className={styles.titleEn}>Story</h2>
              <span className={styles.titleJa}>あらすじ</span>
            </div>
            <div className={styles.inner}>
              <div className={styles.imgWrap}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/story1.png")}
                  alt=""
                />
              </div>
              <div className={styles.body}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/story2.png")}
                  alt=""
                />
                <p>数十年後、人類史上最高の天才と呼ばれる学生、真木 心一。</p>
                <p>
                  彼の元に未来からやってきた崎野
                  夢芽はある使命を帯びているという。
                  <br />
                  タイムマシンの前で微笑む夢芽と悲しい表情の心一。
                  <br />
                  二人の間にある壮絶な運命とは...
                </p>
                <div
                  className={`${styles.introduction} ${styles.introductionPc}`}
                >
                  <p>
                    土岐 隼一（トキ シュンイチ） 声優。
                    <br />
                    <br />
                    5月7日生まれ、東京都出身。A型。出演作品は、『異世界召喚は二度目です』（セツ役）、『勇者が死んだ！』（トウカ・スコット／シオン・ブレイダン役）、『Paradox
                    Live THE
                    ANIMATION』（征木北斎役）、『東京リベンジャーズ』（羽宮一虎役）、『原神』（フレミネ役）、『プロジェクトセカイ
                    カラフルステージ! feat.初音ミク』（神代類役）など。
                  </p>
                </div>
                <div
                  className={`${styles.introduction} ${styles.introductionPc}`}
                >
                  <p>
                    小市 眞琴（コイチ マコト） 声優。
                    <br />
                    <br />
                    2月17日生まれ、東京都出身。出演作品は、『The Legend of
                    Heroes 閃の軌跡 Northern
                    War』（ラヴィアン・ウィンスレット役）、『るろうに剣心
                    -明治剣客浪漫譚-』（明神弥彦役）、『アンデッドガール・マーダーファルス』（馳井静句役）、『地獄楽』（ヌルガイ役）、『シャングリラ・フロンティア〜クソゲーハンター、神ゲーに挑まんとす〜』（オイカッツォ
                    / 魚臣慧役）、『アイドルマスター
                    シンデレラガールズ』（結城晴役）など。
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.btnWrap}>
              <p>＼冒頭32秒を無料で視聴できます！／</p>
              <a
                href="/contents/sayonara-no-mirai"
                target="_blank"
                className={`${styles.btn} ${styles.btnMedium} ${styles.btnPrimary}`}
              >
                ボイスドラマを視聴する
              </a>
            </div>
          </section>

          <section className={styles.interview}>
            <div className={styles.title}>
              <span className={styles.supplement}>
                ＼収録の裏話を公開中！／
              </span>
              <h2 className={styles.titleEn}>Interview</h2>
              <span className={styles.titleJa}>収録後インタビュー</span>
            </div>
            <section className={styles.interviewDetail}>
              <div className={styles.img}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/interview1.png")}
                  alt=""
                />
              </div>
              <div className={styles.body}>
                <div className={styles.titleWrap}>
                  <h3 className={styles.subTitle}>
                    <strong>
                      異質な恋愛での葛藤を表現できたらと思いました。
                    </strong>
                  </h3>
                  <p>土岐 隼一</p>
                </div>
                <div className={styles.titleWrap}>
                  <h3 className={styles.subTitle}>
                    <strong>やりがいのあるキャラクターでした</strong>
                  </h3>
                  <p>小市 眞琴</p>
                </div>
                <div className={styles.textBody}>
                  <p className={styles.interviewer}>
                    ―本日はありがとうございました！お二人とも別々の撮影だったのですが掛け合いがぴったり噛み合っていて、また一瞬で役に入られていたのを拝見しプロの方のすごさを感じました。
                    <br />
                    さっそくですが、今回のストーリーで特に印象に残った部分や魅力はありますか？
                  </p>
                  <p className={styles.Interviewee}>
                    土岐さん：僕も結構SFが好きで、日本海外問わず色んな作品を見るんですけど。
                    <br />
                    主人公自身がタイムスリップで助けに行くというのはよくありますが、未来から1年に1回だけヒロインが主人公の前に現れて助けてくれる、という設定は...
                  </p>
                </div>
                <a
                  href="/interview/sayonara-no-mirai"
                  target="_brank"
                  className={`${styles.btn} ${styles.btnSmall} ${styles.btnTertiary}`}
                >
                  続きを読む
                </a>
              </div>
            </section>
            <section className={styles.present}>
              <div className={styles.img}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/interview2.png")}
                  alt=""
                />
              </div>
              <div className={styles.body}>
                <h3 className={styles.subTitle}>
                  土岐 隼一<small>さん、</small>小市 眞琴<small>さん</small>
                  <br className={styles.brPc} />
                  <strong>直筆のサイン色紙</strong>
                  <br className={styles.brPc} />
                  を抽選で各2名様にプレゼント!
                </h3>
                <div className={styles.textBody}>
                  <p>
                    ツイッターにて公式ツイートに「ボイスドラマの感想」と「どちらのサイン色紙を希望するか」を記載し引用リツイートしていただくと、抽選で土岐隼一さん・小市眞琴さん直筆色紙を各2名様にプレゼント！
                  </p>
                  <p>ご応募の詳細は下記からご確認いただけます。</p>
                </div>
                <Link
                  className={`${styles.btn} ${styles.btnSmall} ${styles.btnTertiary}`}
                  to="/contents/sayonara-no-mirai/detail/present"
                  state={{ background: location }}
                >
                  ご応募の詳細はこちら
                </Link>
              </div>
            </section>
          </section>

          <div className={styles.csp}>
            <p>
              PAZLEはクリエイターを
              <br className={styles.brSp} />
              支援しています！
            </p>
            <img
              className={styles.imgPc}
              src={require("../../../assets/images/content/sayonara-no-mirai/csp_pc.png")}
              alt=""
            />
            <img
              className={styles.imgSp}
              src={require("../../../assets/images/content/sayonara-no-mirai/csp_sp.png")}
              alt=""
            />
          </div>

          <div className={styles.product}>
            <div className={styles.inner}>
              <div className={styles.textBody}>
                <div className={styles.logo}>
                  <img
                    src={
                      require("../../../assets/images/content/logo_footer.svg")
                        .default
                    }
                    alt=""
                  />
                </div>
                <h3 className={styles.subTitle}>
                  話題の声優のボイスドラマが
                  <br className={styles.brPc} />
                  視聴できる「PAZLE<span>（ベータ版）</span>」誕生
                </h3>
                <p>
                  今後も、人気声優さんのボイスドラマを続々配信予定！
                  <br />
                  ぜひ、公式ページもチェックしてください！
                </p>
                <img
                  className={styles.imgContentsSp}
                  src={require("../../../assets/images/content/sayonara-no-mirai/footer_sp.png")}
                  alt=""
                />
                <a
                  href="/about"
                  target="_brank"
                  className={`${styles.btn} ${styles.btnMedium} ${styles.btnSecondary}`}
                >
                  <span>PAZLE公式ページへ</span>
                </a>
              </div>
              <div className={styles.imgContentsPc}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/footer_pc.png")}
                  alt=""
                />
              </div>
              <div className={styles.imgContentsIpad}>
                <img
                  src={require("../../../assets/images/content/sayonara-no-mirai/footer_ipad.png")}
                  alt=""
                />
              </div>
            </div>
          </div>
        </main>

        <footer className={styles.footer}>
          <div className={styles.footerInner}>
            <h3 className={styles.subTitle}>
              その他の新作作品も順次公開予定！
            </h3>
            <ul className={styles.btns}>
              <li>
                <p>＼友達にも共有しよう／</p>
                <a
                  href="http://twitter.com/share?url=pazle.click/contents/sayonara-no-mirai/detail&text=土岐隼一さん、小市眞琴さん出演！タイムマシンを巡る、時を超えたラブストーリー「君の過去にさよならの未来を数えて」&via=Pazle_info&hashtags=PAZLE,声優,ショートドラマ,ボイスドラマ,土岐隼一,小市眞琴"
                  target="_brank"
                  className={`${styles.btn} ${styles.btnSmall} ${styles.btnTertiary} ${styles.btnTw}`}
                >
                  SHARE
                </a>
              </li>
            </ul>
            <div className={styles.snsLinks} id="sns">
              <a
                href="https://twitter.com/Pazle_info"
                target="_brank"
                className={`${styles.btnTw}`}
              >
                フォローする
              </a>
              <a
                href="https://lin.ee/r4SVWtA"
                target="_brank"
                className={styles.btnLine}
              >
                <img
                  src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
                  alt="友だち追加"
                />
              </a>
            </div>
            <div className={styles.inner}>
              <div className={styles.backToTopWrap}>
                <a className={styles.backToTop} href="#main">
                  <img
                    src={
                      require("../../../assets/images/top_arrow_top.svg")
                        .default
                    }
                    alt=""
                  />
                </a>
              </div>
              <ul className={styles.linkList}>
                <li>
                  <a href="https://vectordesign.jp/" target="_brank">
                    運営会社について
                  </a>
                </li>
                <li>
                  <a href="/terms" target="_brank">
                    利用規約
                  </a>
                </li>
                <li>
                  <a href="/privacy" target="_brank">
                    プライバシーポリシー
                  </a>
                </li>
                <li>
                  <a href="/tokutei" target="_brank">
                    特定商取引法に基づく表記
                  </a>
                </li>
                <li>
                  <a href="/requirements" target="_brank">
                    動作環境について
                  </a>
                </li>
              </ul>
              <div className={styles.copylight}>
                <small>©︎2023</small>
                <img
                  src={
                    require("../../../assets/images/top_logo_vector.svg")
                      .default
                  }
                  className={styles.vector}
                  alt=""
                />
                <span>/</span>
                <img
                  src={require("../../../assets/images/logo_white.svg").default}
                  className={styles.pazle}
                  alt=""
                />
              </div>
            </div>
          </div>
        </footer>
      </div>
      <Outlet />
    </>
  );
}

export default ContentSayonaraNoMirai;
